import { MotionValue } from 'framer-motion';

import { createContext, useContext } from 'react';

interface ScrollContextValue {
  scrollYProgress: MotionValue<number>;
}

const ScrollContext = createContext<ScrollContextValue | null>(null);

export const ScrollProvider: React.FC<{
  value: ScrollContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>
  );
};

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScrollContext must be used within a ScrollProvider');
  }
  return context;
};
